<div
  class="avatar-wrapper"
  [class.avatar-wrapper--xs]="size() === 'xs'"
  [class.avatar-wrapper--sm]="size() === 'sm'"
  [class.avatar-wrapper--md]="size() === 'md'"
  [class.avatar-wrapper--lg]="size() === 'lg'"
  [class.avatar-wrapper--xl]="size() === 'xl'"
  [class.avatar-wrapper--xxl]="size() === 'xxl'"
>
  @if (showLetterAvatar()) {
    <span class="avatar-initial" role="img" [attr.aria-label]="alt()">{{ initialLetter() }}</span>
  } @else {
    <img
      class="avatar"
      [src]="avatarUrl()"
      [alt]="alt()"
      loading="lazy"
      decoding="async"
      (error)="onImageError($event)"
    />
  }
</div>
